import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import Settings from './Settings';
import Auth from './Auth';
import Common from './Common';
import Consignment from './Consignment';
import Denominations from './Denomination';
import Users from './Users';
import Intent from './Intent';
import Safecustodycenters from './Safecustody';
import Custodycenters from './Custodycenters';
import Roles from './Roles';
import Resources from './Resources';
import Regions from './Regions';
import Banks from './Banks';
import Bankbranches from './Bankbranches';
import Branches from './Branches';
import Passwordpolicies from './Passwordpolicies';
import Dashboard from './Dashboard';
import Handovers from './Handovers';
import Reports from './Reports';
import FingerPrintDeviceStatus from './FingerPrintDeviceStatus';
import FingerPrintRegistration from './FingerPrintRegistration';
import VerifyFinger from './VerifyFinger';
import UserImages from './UserImages';

export default (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  commonData: Common,
  consignment: Consignment,
  denominations: Denominations,
  users: Users,
  intent: Intent,
  safecustodycenters: Safecustodycenters,
  registeredUser: Users,
  Custodycenters: Custodycenters,
  roles: Roles,
  resources: Resources,
  regions: Regions,
  bankBranches: Bankbranches,
  branches: Branches,
  banks: Banks,
  dashboard: Dashboard,
  passwordpolicies: Passwordpolicies,
  handovers: Handovers,
  reports: Reports,
  FingerPrintDeviceStatus: FingerPrintDeviceStatus,
  FingerPrintRegistration: FingerPrintRegistration,
  userImages: UserImages,
  VerifyFinger: VerifyFinger
});
